import { useQuery, useInfiniteQuery, useMutation, useQueryClient } from 'react-query'
import { api } from '../../utils/api'
import { NotificationType, NotificationWithPaging } from './notitication-typed'

const NOTIFICATION_READ_URL = '/api/digital_news/noti/user_read_news'
const NOTIFITCATION_BASE_URL = '/api/digital_news'
const NOTIFICATION_LIST_URL = `${NOTIFITCATION_BASE_URL}/list_user_notification`
const NOTIFICATION_COUNT_URL = `${NOTIFITCATION_BASE_URL}/getNotiCount`

export const useGetNotificationCount = () => {
  return useQuery<number>(NOTIFICATION_COUNT_URL, () =>
    api.belive.get<number>(NOTIFICATION_COUNT_URL),
    {
      staleTime: 0,
      refetchOnWindowFocus: false,
    }
  )
}

export const useGetNotification = (
  userId?: number,
  maxSize = 0,
  params = {
    page: 1,
    size: 3,
  },
) => {
  const totalPage = Math.ceil(maxSize / params.size)
  return useInfiniteQuery(
    [NOTIFICATION_LIST_URL, { userId, totalPage }],
    async ({ pageParam = 1 }) => {
      const response = await api.belive.get<NotificationType[]>(NOTIFICATION_LIST_URL, {
        page: pageParam,
        pageSize: params.size,
        userId,
      })

      const responseWithPaging: NotificationWithPaging = {
        data: response,
        paging: {
          page: pageParam,
          nextPage: pageParam + 1,
          totalPage,
        },
      }

      return responseWithPaging
    },
    {
      getNextPageParam: (lastGroup: NotificationWithPaging) => {
        const { nextPage, totalPage = 0 } = lastGroup.paging
        return nextPage <= totalPage ? nextPage : null
      },
    },
  )
}

export const useReadNotification = () => {
  const queryClient = useQueryClient()
  const mutate = useMutation(
    async (id: number) => {
      return api.belive.post<number>(NOTIFICATION_READ_URL, {
        notificationId: id,
      })
    },
    {
      // onSuccess: (data) => {
      //   console.log('==== success ===', data)
      // },
      onError: (e: any) => {
        console.log('===== error ====', e)
        if (e.message) {
          console.log(e.message)
        }
      },
    },
  )
  return mutate
}
